import React from 'react';

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/905322574586"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all hover:scale-110"
      style={{ backgroundColor: '#25D366' }}
      data-testid="whatsapp-button"
      aria-label="WhatsApp"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="white">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.914 15.914 0 0016.004 32C24.826 32 32 24.826 32 16.004 32 7.176 24.826 0 16.004 0zm9.32 22.616c-.396 1.116-1.956 2.04-3.216 2.31-.864.186-1.992.33-5.79-1.244-4.86-2.016-7.986-6.93-8.226-7.254-.234-.318-1.914-2.55-1.914-4.86 0-2.316 1.212-3.45 1.644-3.924.396-.432.87-.54 1.158-.54.138 0 .264.006.378.012.432.018.648.042 .93.72.354.846 1.218 2.97 1.326 3.186.108.216.18.474.036.762-.138.294-.21.474-.414.726-.21.252-.438.564-.624.756-.21.216-.426.45-.186.882.246.432 1.086 1.788 2.328 2.898 1.602 1.428 2.946 1.872 3.366 2.076.432.21.684.18.936-.108.252-.288 1.08-1.26 1.368-1.692.288-.432.576-.36.966-.216.396.144 2.508 1.182 2.94 1.398.432.216.72.324.828.504.108.18.108 1.038-.288 2.154z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;
